var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{ref:"scaledImage",attrs:{"src":_vm.src,"alt":_vm.alt,"width":_vm.scaledWidth,"height":_vm.scaledHeight}})}
var staticRenderFns = []

export { render, staticRenderFns }